import Model from "./Model";

export default class extends Model {
    constructor(urls) {
        super(urls);
        this.urls.content_add = urls.route_content_add;
        this.urls.content_del = urls.route_content_del;
        this.urls.device_add = urls.route_device_add;
        this.urls.device_del = urls.route_device_del;
    }

    async loadTable(
      page,
      limit,
      search = '',
      device_type = null,
      brand = null,
      current_sort_column = null,
      current_sort_direction = null
    ) {
        let response = await super.list(
            page,
            limit,
            search,
            {
                'sort_column': current_sort_column,
                'sort_direction': current_sort_direction,
            },
            brand,
            device_type
        ).then(
          result => {return result}
        );
        let result = {
            tbody: [],
            pages: response.pages,
        };
        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(playlist => {
                let telem = {
                    tbody: {}
                };

                telem.id = playlist.id;
                telem.tbody.name = playlist.name;
                telem.tbody.created = playlist.created_at;
                telem.tbody.brand = playlist.brand;
                telem.tbody.user = playlist.user;
                telem.tbody.client_name = playlist.client_name;
                telem.tbody.device_type = playlist.device_type;
                telem.tbody.quantity_locations = playlist.quantity_locations;
                telem.tbody.quantity_devices = playlist.quantity_devices;
                telem.tbody.quantity_content = playlist.quantity_content;
                telem.tbody.regions = playlist.regions;
                telem.tbody.status = playlist.status;
                result.tbody.push(telem);
            });
        }
        return result;
    }

    async addContent(playlist_id, content_id) {
        if(this.urls.content_add === undefined)
        {
            console.log('error: url_content_add_undefined');
            return false;
        }
        return await axios.post(this.urls.content_add, {
            playlist_id: playlist_id,
            content_id: content_id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async delContent(playlist_id, content_id) {
        if(this.urls.content_del === undefined)
        {
            console.log('error: url_content_del_undefined');
            return false;
        }
        return await axios.post(this.urls.content_del, {
            playlist_id: playlist_id,
            content_id: content_id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async addDevice(playlist_id, device_id) {
        if(this.urls.device_add === undefined)
        {
            console.log('error: url_device_add_undefined');
            return false;
        }
        return await axios.post(this.urls.device_add, {
            playlist_id: playlist_id,
            device_id: device_id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async delDevice(playlist_id, device_id) {
        if(this.urls.device_del === undefined)
        {
            console.log('error: url_device_del_undefined');
            return false;
        }
        return await axios.post(this.urls.device_del, {
            playlist_id: playlist_id,
            device_id: device_id
        }).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }
}
